<template>
    <div class="interest-form"
        :style="{
      background: `url(${formCustomShow.activityPictureUrl}) 0% 0% / 100% 100% no-repeat`,
    }">
        <login-in :loginType="loginType"
            :isLoginFlag="isLoginFlag"
            :activityTypeFlag="activityTypeFlag"
            :activityUrl="activityUrl"></login-in>
        <!-- 点击开始答题显示弹窗内容 -->
        <div v-if="showAnswer"
            class="answer-content-dialog">
            <div v-for="(item, index) in questionList"
                :key="index">
                <!-- 默认展示第一道题 -->
                <div v-show="index === currentPage"
                    class="question-content">
                    <!-- 题目为单选时 -->
                    <div v-if="item.questionType === 'single_choice'"
                        class="single-choice">
                        <!-- 题目标题 -->
                        <div class="answer-title">
                            <span>{{ currentPage + 1 }}. {{ item.title }}</span>
                            <span class="single-choice-text">单选题</span>
                        </div>
                        <!-- 题目选项 -->
                        <div class="answer-content-height">
                            <div v-for="(item1, index1) in item.optionList"
                                :key="index1"
                                class="answer-content">
                                <div class="answer-option"
                                    :class="{
                    'selected-answer-option': item1._isSelect,
                  }"
                                    @click="selectOption(item, item1, index1)">
                                    <span> {{ item1.optionContent }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 题目为其它题型时，走普通表单题型组件逻辑 -->
                    <div v-else
                        class="question-content-other">
                        <div class="dynamic-property-form">
                            <component :is="item.questionType"
                                :attrObj="item"
                                :currentPage="currentPage"
                                @selectOption="selectOption"></component>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 按钮：第一页：上一题禁用，最后一页：下一题隐藏，提交展示，中间页正常展示上一题和下一题 -->
            <!-- 展示条件：只有分值且开启自动切换题目 -->
            <div class="btn-list">
                <van-button v-if="
            formCustomShow.questionGamePlays === '1' &&
            formCustomShow.questionAutoSwitch === 1
          "
                    type="info"
                    class="btn"
                    :disabled="currentPage == 0 ? true : false"
                    @click="toUp()">上一题</van-button>
                <van-button v-if="
            formCustomShow.questionGamePlays === '1' && isAllSingleChoice && showNextBut
          "
                    type="info"
                    class="btn"
                    @click="toNext()">下一题</van-button>
                <van-button v-if="
            formCustomShow.questionGamePlays === '1' && isAllSingleChoice && !showNextBut
          "
                    type="info"
                    class="btn"
                    @click="handleSubmit()">提交</van-button>
            </div>
            <!-- 第X题/共X题 展示条件：只有分值且开启进度展示-->
            <div v-if="
          formCustomShow.questionGamePlays === '1' &&
          formCustomShow.questionAnswerProgress === 1
        "
                class="answer-process">
                <div class="current">
                    <span>第{{ currentPage + 1 }}题/</span>
                </div>
                <div class="sum">
                    <span>共{{ questionList.length }}题</span>
                </div>
            </div>
        </div>

        <!-- 提交后抽奖弹窗 -->
        <van-popup v-model="showPrize"
            class="dialog"
            closeable
            :transition-appear="true"
            transition="fade"
            duration="1"
            close-icon="cross">
            <div class="dialog-content">
                <div class="dialog-img">
                    <img src="../../../../../static/runtime/images/magic/answer-question.png"
                        alt="" />
                </div>
                <div class="content-top">
                    <span>恭喜任务达成</span>
                </div>
                <!-- 戳我下一步展示条件 -->
                <div v-if="buttonShow"
                    class="content-bottom">
                    <div class="v-button">
                        <van-button round
                            color="#256FFF"
                            @click="goNextActivityFn">
                            <span class="fs-16">戳我下一步</span>
                        </van-button>
                    </div>
                </div>
                <!-- 分享展示条件 -->
                <div v-if="loginType === 'wechat' && formCustom.shareFlag === '1'"
                    class="share"
                    @click="openGuide()">
                    <img src="../../../../../static/image/分享.png"
                        alt="" />
                    <span style="color: #315dd2">分享</span>
                </div>
            </div>
        </van-popup>
        <!-- 活动未开始 -->
        <van-popup v-model="showNoStart"
            class="dialogEnd"
            closeable
            close-icon="close">
            <div class="endTitle">
                <span>活动未开始</span>
            </div>
            <div class="endImage">
                <img src="../../../../../static/image/未开始.png"
                    alt="" />
            </div>
            <div class="activityTime">
                <span>{{ "尊敬的用户，您参与的这个活动时间为" }}</span><br />
                <span class="time">{{
          `（${formCustom.activityStartTime}-${formCustom.activityEndTime}）`
        }}</span><br />
                <span>{{ "活动未开始，请稍后参加!" }}</span><br />
            </div>
        </van-popup>
        <!-- 活动结束弹窗 -->
        <van-popup v-model="showEnd"
            class="dialogEnd"
            closeable
            close-icon="close">
            <div class="endTitle">
                <span>活动已结束</span>
            </div>
            <div class="endImage">
                <img src="../../../../../static/image/已结束.png"
                    alt="" />
            </div>
            <div class="activityTime">
                <span>{{ "尊敬的用户，您参与的这个活动时间为" }}</span><br />
                <span class="time">{{
          `（${formCustom.activityStartTime}-${formCustom.activityEndTime}）`
        }}</span><br />
                <span>{{ "活动已结束，请后续再参加!" }}</span><br />
            </div>
        </van-popup>
        <!-- 活动对应状态按钮 -->
        <div v-if="!showAnswer"
            class="button-status-text"
            :class="{ 'button-text': !['1'].includes(formCustom.activityStatus) }"
            @click="startAnswer(formCustom)">
            <!-- 进行中活动开始答题按钮根据图片配置 -->
            <span v-if="['1'].includes(formCustom.activityStatus)">
                <img class="start-answer-img"
                    :src="formCustomShow.questionAnswerImgUrl" />
            </span>
            <span v-else>
                {{ getButStatusText(formCustom.activityStatus) }}
            </span>
        </div>
        <!-- 页脚 -->
        <div class="footer">
            <span>最终解释权归荣耀终端股份有限公司所有</span>
        </div>
        <!-- 分享配置 -->
        <share-set v-if="loginType === 'wechat' && formCustom.shareFlag === '1'"
            :formCustom="formCustom"
            @getPoster="getPoster">
        </share-set>
        <share-poster v-if="isShowPoster"
            :formCustom="formCustom"> </share-poster>
        <IncorrectClient :isDisplay="!isCorrectClient"
            :loginType="originLoginType"></IncorrectClient>
    </div>
</template>

<script>
import { Progress, Icon, Image as VanImage, Button, Popup, Divider, Toast } from 'vant';
import wx from 'weixin-js-sdk';
import 'animate.css';
import loginIn from '../dynamicAttr/modal/login-in.vue';
import comUtils, { loadAlipayWebViewScript } from '../../../../utils/comUtils';
import single_choice from '../dynamicAttr/radio';
import multiple_choice from '../dynamicAttr/checkbox';
import single_text from '../dynamicAttr/input';
import multiple_text from '../dynamicAttr/textarea';
import attachment from '../dynamicAttr/fileUpload';
import form_time from '../dynamicAttr/time';
import evaluation from '../dynamicAttr/score';
import submittedForm from '../submittedForm';
import formCouponModal from '../dynamicAttr/modal/form-coupon-modal';
import address_text from '../dynamicAttr/address';
import name_text from '../dynamicAttr/nameText';
import phone_text from '../dynamicAttr/phoneText';
import { ActivityStatus } from '../../../../commons/commonVariables.js';
import shareSet from './components/share-set.vue';
import sharePoster from './components/share-poster.vue';
import IncorrectClient from '../dynamicAttr/incorrect-client.vue';
import { AMapGetLocation } from '../TMap.js';
import { checkClient } from '../common-methods/utils';
export default {
  components: {
    [Progress.name]: Progress,
    [Icon.name]: Icon,
    [VanImage.name]: VanImage,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Divider.name]: Divider,
    loginIn,
    shareSet,
    single_choice,
    multiple_choice,
    single_text,
    multiple_text,
    attachment,
    form_time,
    evaluation,
    submittedForm,
    formCouponModal,
    address_text,
    name_text,
    phone_text,
    sharePoster,
    IncorrectClient,
  },
  data() {
    return {
      answer: [],
      isShowPoster: false, // 默认不展示分享海报
      showAnswer: false, // 开始答题弹窗
      showPrize: false, // 提交后抽奖弹窗
      showEnd: false, // 活动结束弹窗
      showNoStart: false, // 活动未开始弹窗
      buttonShow: false, // 抽奖弹框是否显示分享按钮
      nextActivity: '', // 抽奖弹框点击去抽奖配置的活动
      activityCode: '', //活动编码
      // 赋值后用于保存
      formCustom: {
        activityEndTime: '', // 活动开始时间
        activityStartTime: '', // 活动结束时间
      },
      // 只用于表单展示
      formCustomShow: {
        activityPictureUrl: '', // 答题背景图片
        questionAnswerImgUrl: '', // 开始答题按钮配置
        questionGamePlays: '', // 自定义表单，趣味表单玩法类型，1分值2跳题
        questionAnswerProgress: '', // 自定义表单，趣味表单-进度展示，1是0否
        questionAutoSwitch: '', // 自定义表单，趣味表单-自动切换题目，1是0否
        // shareButtonPosition: "3", // 趣味表单-分享按钮位置，1左上2左下3右上4右下
        // sharePosterImgUrl: "", // 分享海报
        // qrcodeFilePath: "", // 分享对应的二维码
        // shareButtonStyleImgUrl: "", // 分享按钮图标
      },
      loginType: '', //登录方式
      miniprogramFlag: false, //判断是否在小程序环境内打开
      activityUrl: '', // 当前活动地址
      isLoginFlag: false, // 默认没有登录
      activityTypeFlag: '', // 小程序类型：1体验店（hi荣耀），2直营店
      questionList: [],
      currentPage: 0, // 当前页，默认展示问题集合的第一条数据
      showNextBut: true, // 用于判断展示下一题还是提交按钮
      isAllSingleChoice: false, // 展示下一题还是提交按钮，题型包含非单选时，即使关闭题目切换按钮，也展示
      isCorrectClient: true, // 是否在正确的客户端打开
      originLoginType: '', // 原始登录类型（转换前）
      positionInfo: {},
    };
  },
  computed: {},
  created() {
    this.loginType = sessionStorage.getItem('loginType') || '';
    // 判断是否在小程序内
    this.handleMiniprogramJudge();
    this.activityTypeFlag = sessionStorage.getItem('activityTypeFlag') || '';
    const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
    const code = this.$route.query && this.$route.query.activityCode;
    this.activityCode = code;
    // 组装当前地址
    this.activityUrl = location.origin + '/hd/hdmain?activityCode=' + code;
    if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
      this.activityUrl =
        this.activityUrl + '&ay=' + eventTrackingData.activityType + '&GUID=' + eventTrackingData.guideUserId + '&SC=' + eventTrackingData.storeCode;
    }
    this.isLoginFlag = sessionStorage.getItem('isLoginFlag') === 'true' ? true : false;
    //表单初始化
    this.initFormData();
  },
  mounted() {
    this.originLoginType = sessionStorage.getItem('originLoginType');
    this.isCorrectClient = checkClient(this.originLoginType);
  },
  methods: {
    getPoster(val) {
      this.isShowPoster = false;
      this.$nextTick(() => {
        this.isShowPoster = val;
      });
    },
    //初始化表单数据
    async initFormData() {
      this.$api.post({
        noLoading: true,
        sc: 'mobileMarketingH5',
        url: 'questionActivity/queryMiniActivityQuestionDetail/' + this.activityCode,
        params: {
          longitude: '',
          dimension: '',
        },
        success: (r) => {
          const result = r.result || {};
          //活动已结束
          if (r.result.activityStatus === ActivityStatus.finished) {
            this.showEnd = true;
          }
          //活动未开始
          if (r.result.activityStatus === ActivityStatus.notStarted) {
            this.showNoStart = true;
          }
          //获取活动编码
          this.activityCode = result.activityCode;
          this.formCustom = Object.assign({}, result);
          // 如果只有一道题，说明当前页就是最后一题时，下一题按钮隐藏，提交按钮展示
          if (result.questionList && result.questionList.length === 1) {
            this.showNextBut = false;
          }
          // 问题集合
          this.questionList = result.questionList;
          if (result.activityConfig.questionAutoSwitch === 1) {
            // 如果开启题目切换按钮，不管题型，都展示下一题按钮
            this.isAllSingleChoice = true;
          } else {
            // 如果关闭题目切换按钮，全是单选，不展示下一题按钮，包含有其它题型展示下一题按钮
            const noSingleChoice = this.questionList.findIndex((item) => item.questionType !== 'single_choice');
            if (noSingleChoice > -1) {
              this.isAllSingleChoice = true;
            }
          }

          // 给每条问题增加下表单类型，因为和普通表单共用题型组件，方便只对趣味表单加样式
          if (this.questionList.length) {
            this.questionList.forEach((item) => {
              item.formType = result.formType;
            });
          }
          if (result.activityConfig) {
            this.formCustomShow.questionGamePlays = result.activityConfig.questionGamePlays;
            this.formCustomShow.questionAnswerProgress = result.activityConfig.questionAnswerProgress;
            this.formCustomShow.questionAutoSwitch = result.activityConfig.questionAutoSwitch;
            // 答题背景图片
            if (result.activityPictureUrl) {
              if (result.activityPictureUrl.indexOf('{') > -1) {
                this.formCustomShow.activityPictureUrl = this.$utils.getImageUrl(JSON.parse(result.activityPictureUrl).file);
              } else {
                this.formCustomShow.activityPictureUrl = this.$utils.getImageUrl(result.activityPictureUrl);
              }
            }
            // 分享设置位置，1左上2左下3右上4右下
            this.formCustom.activityConfig.shareButtonPosition = result.activityConfig.shareButtonPosition;
            // 分享按钮图标
            if (result.activityConfig.shareButtonStyleImgUrl) {
              if (result.activityConfig.shareButtonStyleImgUrl.indexOf('{') > -1) {
                this.formCustom.activityConfig.shareButtonStyleImgUrl = this.$utils.getImageUrl(JSON.parse(result.activityConfig.shareButtonStyleImgUrl).file);
              } else {
                this.formCustom.activityConfig.shareButtonStyleImgUrl = this.$utils.getImageUrl(result.activityConfig.shareButtonStyleImgUrl);
              }
            } else {
              // 如果pc端分享按钮样式选择默认，又分为选择左上和左下对应是一种图标，右上和右下是另一种图标
              if (['1', '2'].includes(this.formCustom.activityConfig.shareButtonPosition)) {
                this.formCustom.activityConfig.shareButtonStyleImgUrl = require('../../../../../static/image/shareIcon-left.png');
              } else {
                this.formCustom.activityConfig.shareButtonStyleImgUrl = require('../../../../../static/image/shareIcon-right.png');
              }
            }
            // 开始答题按钮配置
            if (result.activityConfig.questionAnswerImgUrl) {
              if (result.activityConfig.questionAnswerImgUrl.indexOf('{') > -1) {
                this.formCustomShow.questionAnswerImgUrl = this.$utils.getImageUrl(JSON.parse(result.activityConfig.questionAnswerImgUrl).file);
              } else {
                this.formCustomShow.questionAnswerImgUrl = this.$utils.getImageUrl(result.activityConfig.questionAnswerImgUrl);
              }
            } else {
              this.formCustomShow.questionAnswerImgUrl = require('../../../../../static/runtime/images/magic/begin-answer.png');
            }
            // 分享海报
            if (result.activityConfig.sharePosterImgUrl) {
              if (result.activityConfig.sharePosterImgUrl.indexOf('{') > -1) {
                this.formCustom.activityConfig.sharePosterImgUrl = this.$utils.getImageUrl(JSON.parse(result.activityConfig.sharePosterImgUrl).file);
              } else {
                this.formCustom.activityConfig.sharePosterImgUrl = this.$utils.getImageUrl(result.activityConfig.sharePosterImgUrl);
              }
            }
            // 分享对应的二维码
            if (result.activityConfig.qrcodeFilePath) {
              if (result.activityConfig.qrcodeFilePath.indexOf('{') > -1) {
                this.formCustom.activityConfig.qrcodeFilePath = this.$utils.getImageUrl(JSON.parse(result.activityConfig.qrcodeFilePath).file);
              } else {
                this.formCustom.activityConfig.qrcodeFilePath = this.$utils.getImageUrl(result.activityConfig.qrcodeFilePath);
              }
            }
          }
        },
      });
    },
    // 根据活动状态展示按钮文案
    getButStatusText(val) {
      let butText = '';
      switch (val) {
        case '0':
          butText = '活动未开始';
          break;
        case '3':
          butText = '活动已结束';
          break;
      }
      return butText;
    },
    // 开始答题，进行中且未参与的的活动才允许答题
    startAnswer(obj) {
      if (!this.isLoginFlag) {
        this.$utils.tips.message('warning', '您还未登录，请登录荣耀会员参与活动');
        return;
      }
      // 检测当前活动是否参与过，参与过的话直接跳转到抽奖弹窗
      const isJoinedArr = JSON.parse(sessionStorage.getItem('interestFormAnswer')) ? JSON.parse(sessionStorage.getItem('interestFormAnswer')) : [];
      // 参加过该活动又区分分值和跳题，分值的话直接看第一条数据即可，跳题只能看最后一条数据
      if (isJoinedArr && isJoinedArr.length) {
        // 展示抽奖弹框，可以用于去抽奖、分享操作
        this.showPrize = true;
        // 有配置的关联组件，才显示去抽奖按钮，分值时根据接口返回的关联编码跳转
        if (this.formCustomShow.questionGamePlays === '1') {
          if (isJoinedArr[0] && isJoinedArr[0].userJumpActivityCode) {
            this.buttonShow = true;
            this.nextActivity = isJoinedArr[0].userJumpActivityCode;
          }
        } else {
          // 跳题时，最后一题绑定的每个选项就有关联组件编码
          const jumpActivityObj = isJoinedArr[isJoinedArr.length - 1];
          if (jumpActivityObj && jumpActivityObj.answerVO && jumpActivityObj.answerVO.jumpActivityCode) {
            this.buttonShow = true;
            this.nextActivity = jumpActivityObj.answerVO.jumpActivityCode;
          }
        }
      } else {
        if (!['1'].includes(obj.activityStatus)) {
          return false;
        }
        this.showAnswer = true;
        // 点击开始答题埋码上报
        this.handleCodeAnswer();
      }
    },
    // 埋码事件-开始答题
    handleCodeAnswer() {
      const params = {
        actionCode: 500030003,
        actionName: '趣味表单-开始答题',
        content: {
          title: '趣味表单-开始答题',
          channel: this.loginType === 'wechat' ? '微信' : '支付宝',
          load: 1,
          eventType: 1,
          activityCode: this.activityCode,
          url: location.origin + '/hd/hdmain?activityCode=' + this.activityCode,
        },
      };
      const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
      if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
        params.content.activityName = eventTrackingData.activityName;
        params.content.activityType = eventTrackingData.activityType;
        params.content.guideUserId = eventTrackingData.guideUserId;
        params.content.channelCode = eventTrackingData.storeCode;
      }
      comUtils.handleBatchReport(this, params);
    },
    // 选择每道题选项
    selectOption(questionObj, optionObj, currentIndex) {
      if (questionObj.questionType === 'single_choice') {
        // 选择当前选项时，先给每个选项设置为false，再对选中项设为true
        questionObj.optionList.filter((item) => this.$set(item, '_isSelect', false));
        questionObj.optionList[currentIndex]._isSelect = true;
      }
      //如果是跳题类型，跳题类型只有单选题
      setTimeout(() => {
        // questionGamePlays:趣味表单玩法类型，1分值2跳题
        // jumpType：跳题对应的跳转类型 1跳题：2跳组件
        // jumpProblem：跳题(next:下一题，实际可能返回null; end:跳至末尾; 其他的存储字段代表所跳的问题排序)，当为跳组件为组件code
        if (this.formCustomShow.questionGamePlays === '2') {
          // 跳题时，针对单选无地方校验是否做该题，也无地方组装数据，在选择的时候就需要把数据组装好
          let text = '';
          const textArr = [];
          questionObj.optionList.filter((items) => {
            if (items._isSelect) {
              text = items.optionCode + ':' + items.optionContent;
              textArr.push(text);
            }
            questionObj.answerContent = textArr.join(',');
          });
          if (optionObj.jumpType === '2') {
            // jumpType为"2"，说明是最后一题，所有题型只有一道题会返回"2"
            // 关联组件编码字段jumpProblem非必填，有的话入参传一下
            this.formCustom.jumpProblem = optionObj.jumpProblem || '';
            this.handleSave(this.formCustom);
          } else {
            if (optionObj.jumpProblem === 'end') {
              // 跳转到最后一题，先获取到最后一题位置，再获取到需要跳转几步
              const len = this.questionList.length - 1;
              const step = len - this.currentPage;
              this.currentPage += step;
            } else if (optionObj.jumpProblem === null || optionObj.jumpProblem === 'next') {
              // 跳转到下一题，当前页加1
              this.currentPage++;
            } else {
              // 如果跳转的既不是下一题，也不是最后一题，也不是关联组件编码，返回的是具体数字字符串
              const goNum = Number(optionObj.jumpProblem) - 1;
              const len = this.questionList.length - 1;
              // 针对可能存在乱配置跳题，则不跳。如总共只要4道题，配置跳转到第5道及以上
              if (goNum > len) {
                return false;
              }
              const step = goNum - this.currentPage;
              this.currentPage += step;
            }
          }
        } else if (
          // 如果是分值，并且关闭自动切换题目即不展示上一题/下一题按钮，默认跳到下一题
          this.formCustomShow.questionGamePlays === '1' &&
          this.formCustomShow.questionAutoSwitch === 0
        ) {
          this.toNext();
        }
      }, 500);
    },
    // 点击上一题
    toUp() {
      this.currentPage--;
      // 当前页等于最后一题时，下一题按钮隐藏，提交按钮展示
      this.showNextBut = true;
    },
    // 点击下一题
    toNext() {
      // 获取到当前题
      const questionListCur = this.questionList[this.currentPage];
      // 校验当前题是不是最后一题
      const isLastQuestion = this.currentPage === this.formCustom.questionList.length - 1;
      // 先校验是否做了当前题目，再校验输入的是否正确
      this.handleCheck(questionListCur, isLastQuestion);
    },
    // 点击下一题或者点击提交时，校验是当前题目完成没，再校验输入的是否正确
    handleCheck(questionListCur, isLastQuestion) {
      if (['single_choice', 'multiple_choice'].includes(questionListCur.questionType)) {
        // 组装answerContent，用于保存入参和点击下一题校验
        let text = '';
        const textArr = [];
        questionListCur.optionList.filter((items) => {
          if (items._isSelect) {
            text = items.optionCode + ':' + items.optionContent;
            textArr.push(text);
          }
          questionListCur.answerContent = textArr.join(',');
        });
      }
      // 点击下一题或者点击提交需要完成当前题目
      if (!questionListCur.answerContent) {
        const content = '请完成当前题目';
        Toast(content);
        return false;
      }
      // 对部分输入的内容进行校验
      let checkMustFlag = false,
        phoneFlag = false,
        addressFlag = false,
        isFile = false;
      //如果答案没值则校验不通过，如果未上传附件也校验不过
      if (
        (questionListCur.answerContent && questionListCur.answerContent.toString().trim()) ||
        (questionListCur.questionType === 'attachment' && questionListCur.answerContent) ||
        questionListCur.answerContent === 0
      ) {
        this.$set(questionListCur, 'isCheckError', false);
      } else {
        this.$set(questionListCur, 'isCheckError', true);
        if (questionListCur.phoneNumberVerification && questionListCur.phoneNumberVerification !== '0') {
          this.$set(questionListCur, 'errorMsg', '请输入你的手机号');
        }
        checkMustFlag = true;
      }
      // 校验上传附件
      if (questionListCur.questionType === 'attachment') {
        if (questionListCur.answerContent.length) {
          this.$set(questionListCur, 'isCheckError', false);
          isFile = false;
        } else {
          this.$set(questionListCur, 'isCheckError', true);
          isFile = true;
        }
      }
      // 校验地址
      if (questionListCur.questionType === 'address_text') {
        const answer = JSON.parse(questionListCur.answerContent);
        if (!answer.province || !answer.city || !answer.zone) {
          this.$set(questionListCur, 'isCheckError', true);
          this.$set(questionListCur, 'errorMsg', '请选择地区');
          addressFlag = true;
        } else if (!answer.detail) {
          this.$set(questionListCur, 'isCheckError', true);
          this.$set(questionListCur, 'errorMsg', '请输入详细地址');
          addressFlag = true;
        } else if (answer.detail && answer.detail.length < 5) {
          this.$set(questionListCur, 'isCheckError', true);
          this.$set(questionListCur, 'errorMsg', '详细地址不能小于五个字符');
          addressFlag = true;
        }
      }
      if (questionListCur.phoneNumberVerification && questionListCur.phoneNumberVerification !== '0') {
        if (questionListCur.answerContent && questionListCur.answerContent.trim()) {
          if (!/^1[0-9]{10}$/.test(questionListCur.answerContent)) {
            this.$set(questionListCur, 'isCheckError', true);
            this.$set(questionListCur, 'errorMsg', '请输入正确的手机号');
            phoneFlag = true;
          } else {
            this.$set(questionListCur, 'isCheckError', false);
          }
        } else if (questionListCur.mustFlag === '0') {
          this.$set(questionListCur, 'isCheckError', false);
        }
      }
      if (questionListCur.phoneNumberVerification === '2' && questionListCur.answerContent && !phoneFlag) {
        if (questionListCur.verificationCode && questionListCur.verificationCode.trim()) {
          this.$set(questionListCur, 'isCheckError', false);
        } else {
          this.$set(questionListCur, 'isCheckError', true);
          this.$set(questionListCur, 'errorMsg', '请输入验证码');
          phoneFlag = true;
        }
      }
      if (questionListCur.questionType === 'attachment' && Array.isArray(questionListCur.answerContent)) {
        if (questionListCur.answerContent.length) {
          const answerAttachment = questionListCur.answerContent;
          const attachmentType = questionListCur.attachmentType === '0' ? '图片' : '视频';
          let answerString = '';
          answerAttachment.forEach((element) => {
            if (element.path && element.status === 'done') {
              this.$set(questionListCur, 'isCheckError', false);
              if (!answerString) {
                answerString = element.path;
              } else {
                answerString = answerString + ',' + element.path;
              }
              questionListCur.answerContent = answerString;
            } else if (element.status === 'uploading') {
              this.$set(questionListCur, 'isCheckError', true);
              Toast('请等待当前文件上传完毕');
              isFile = true;
            } else if (element.status === 'failed') {
              this.$set(questionListCur, 'isCheckError', true);
              Toast(`${attachmentType}上传失败，重新上传后方可提交表单`);
              isFile = true;
            }
          });
        } else {
          questionListCur.answerContent = '';
        }
      }
      //校验不过，弹出提示
      if (checkMustFlag || phoneFlag || addressFlag || isFile) {
        return false;
      } else {
        this.formCustom.questionList.forEach((item) => {
          if (item.phoneNumberVerification === '2') {
            this.formCustom.verificationCode = item.verificationCode;
            this.formCustom.redisKey = item.redisKey;
          }
        });
      }
      if (isLastQuestion) {
        // 如果当前题是最后一题，点击提交按钮调服务
        this.handleSave(this.formCustom);
      } else {
        // 点击下一题按钮跳转到下一题
        this.currentPage++;
        // 当前页等于最后一题时，下一题按钮隐藏，提交按钮展示
        if (this.currentPage === this.questionList.length - 1) {
          this.showNextBut = false;
        } else {
          this.showNextBut = true;
        }
      }
    },
    // 分值时，提交数据-校验
    handleSubmit() {
      const formCustom = this.formCustom;
      // 获取当前页(即最后一页)
      const lastQuestion = formCustom.questionList[formCustom.questionList.length - 1];
      // 点击提交时，当前页(即最后一页)先校验是否做了当前题目，再校验输入的是否正确
      this.handleCheck(lastQuestion, true);
    },
    // 提交数据-保存
    handleSave(params) {
      const formCustom = this.formCustom;
      let userBase = this.$store.state.userInfo.userBase;
      let userInfo = sessionStorage.getItem('userInfo');
      if (userInfo) {
        userInfo = JSON.parse(userInfo);
        userBase = Object.assign(userBase, userInfo);
      }
      let userGender = '';
      if (userBase.sex === 1 || userBase.gender === 'm') {
        userGender = '1';
      } else if (userBase.sex === 2 || userBase.gender === 'f') {
        userGender = '2';
      }
      params = Object.assign(formCustom, userBase);
      params.userOpenid = userBase.openId || '';
      params.userUnionid = userBase.unionid || '';
      params.userGender = userGender;
      params.nickName = userBase.nickName;
      params.alipayUserId = sessionStorage.getItem('alipayUserId') || '';
      params.questionList.forEach((item) => {
        item.optionList &&
          item.optionList.forEach((el) => {
            this.$set(el, 'selectFlag', el._isSelect);
          });
        item.answerContent = item.answerContent || '';
        item.mustFlag = item.mustFlag === '0' && item.answerContent === '' ? '' : item.mustFlag;
      });
      const extendConfig = this.$utils.getStorageItemObj('extendConfig');
      params.times = extendConfig && extendConfig.times;
      params.activityCode = this.activityCode;
      params.associationActivityCode = sessionStorage.getItem('associationActivityCode');
      let crtlParams = sessionStorage.getItem('crtlParams');
      if (crtlParams) {
        crtlParams = JSON.parse(crtlParams);
        params.loginType = crtlParams.loginType;
        params.times = 'once';
      }
      if (sessionStorage.getItem('connectionId')) {
        params.connectionId = sessionStorage.getItem('connectionId');
      }
      if (!sessionStorage.getItem('alipayUserId')) {
        // 支付宝已经是隐私结构体了
        const privacyKeys = {
          nickName: '$PrivacyPlain$',
        };
        //隐私信息保存
        const privacyKeyList = [
          {
            nickName: 'nickName',
            typeText: 'NICK_NAME',
            labelText: 'mktStudentRewardRecodeNickName',
          },
        ];
        this.$utils.privacySave(privacyKeys, privacyKeyList, params);
      }
      this.$api.post({
        sc: 'mobileMarketingH5',
        params: params,
        notFilterNull: true,
        url: 'questionActivity/editQuestionAnswer',
        success: (r) => {
          if (r.code === 200) {
            const result = r.result || {};
            if (result.connectionId) {
              sessionStorage.setItem('connectionId', result.connectionId);
            }
            // 提交之后关闭答题弹框
            this.showAnswer = false;
            // 展示抽奖弹框，可以用于去抽奖、分享操作
            this.showPrize = true;
            // 有配置的关联组件，才显示去抽奖按钮，分值时根据接口返回的关联编码跳转
            if (this.formCustomShow.questionGamePlays === '1') {
              if (result.userJumpActivityCode) {
                this.buttonShow = true;
                this.nextActivity = result.userJumpActivityCode;
              }
            } else {
              // 跳题时，最后一题绑定的每个选项就有关联组件编码
              if (this.formCustom.jumpProblem) {
                this.buttonShow = true;
                this.nextActivity = this.formCustom.jumpProblem;
              }
            }
            this.queryUserAnswer();
          } else {
            let content = '活动过于火爆，请稍后再试';
            if (r && r.message) {
              content = r.message;
            }
            Toast(content);
          }
        },
      });
    },
    //查询已提交数据，主要用于已经答过题，不是再次扫码进入而是直接再次点击开始答题，也不允许答题直接到中奖弹框
    queryUserAnswer() {
      const userBase = this.$store.state.userInfo.userBase;
      const userUnionid = userBase.unionid || sessionStorage.getItem('userUnionid');
      const userOpenid = userBase.userOpenid || sessionStorage.getItem('userOpenid');
      let loginType = sessionStorage.getItem('loginType');
      let crtlParams = sessionStorage.getItem('crtlParams');
      if (crtlParams) {
        crtlParams = JSON.parse(crtlParams);
        loginType = crtlParams.loginType;
      }
      const params = {
        activityCode: this.activityCode,
        userUnionid: userUnionid || '',
        loginType: loginType,
        userOpenid: userOpenid || '',
        alipayUserId: sessionStorage.getItem('alipayUserId') || '',
        connectionId: sessionStorage.getItem('connectionId'),
        associationActivityCode: sessionStorage.getItem('associationActivityCode'),
      };
      this.$api.post({
        sc: 'mobileMarketingH5',
        url: 'questionActivity/queryUserQuestionAnswer',
        params: params,
        success: (r) => {
          if (r.code === 200) {
            const list = r.result || [];
            // 缓存下数据用于点击开始答题判断
            if (list && list.length) {
              sessionStorage.setItem('interestFormAnswer', JSON.stringify(list));
            }
          } else {
            Toast(r.message);
          }
        },
      });
    },
    // 配置的关联组件去抽奖
    goNextActivityFn() {
      const parentPageParams = {
        activityCode: this.nextActivity,
        parentPage: 'customForm_interestForm',
        parentActivityCode: this.activityCode,
      };
      const path = comUtils.appendParamsToURL(parentPageParams);
      this.$router.push({
        path: path,
      });
      // 关联活动埋码
      this.handleCodeAward();
    },
    // 埋码事件-关联活动
    handleCodeAward() {
      const params = {
        actionCode: 500030004,
        actionName: '趣味表单-关联活动',
        content: {
          title: '趣味表单-关联活动',
          channel: this.loginType === 'wechat' ? '微信' : '支付宝',
          load: 1,
          eventType: 1,
          activityCode: this.nextActivity,
          url: location.origin + '/hd/hdmain?activityCode=' + this.activityCode,
        },
      };
      const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
      if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
        params.content.activityName = eventTrackingData.activityName;
        params.content.activityType = eventTrackingData.activityType;
        params.content.guideUserId = eventTrackingData.guideUserId;
        params.content.channelCode = eventTrackingData.storeCode;
      }
      comUtils.handleBatchReport(this, params);
    },
    //打开分享引导提示
    openGuide() {
      sessionStorage.setItem('activityConfig', JSON.stringify(this.formCustom));
      this.isShowPoster = false;
      this.$nextTick(() => {
        this.isShowPoster = true;
      });
    },
    // 判断是否在小程序内
    handleMiniprogramJudge() {
      const that = this;
      if (this.loginType === 'wechat') {
        //判断是否在微信小程序环境
        wx.miniProgram.getEnv(function (res) {
          if (res.miniprogram) {
            that.miniprogramFlag = res.miniprogram;
          }
        });
      } else if (this.loginType === 'Alipay') {
        loadAlipayWebViewScript().then((res) => {
          if (res) {
            //判断是否运行在支付宝小程序环境里
            my.getEnv(function (res) {
              if (res.miniprogram) {
                that.miniprogramFlag = res.miniprogram;
              }
            });
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.interest-form {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: scroll;

  // 活动状态对应按钮
  .button-status-text {
    position: fixed;
    bottom: 10%;
  }
  .start-answer-img {
    width: 62.133vw;
    height: 12vw;
  }
  .button-text {
    background: #e2e2e2;
    border-radius: 36px;
    width: 233px;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-family: HYQiHei-EES;
      font-size: 18px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 400;
    }
  }
  // 页脚
  .footer {
    width: 100%;
    position: fixed;
    bottom: 3%;
    display: flex;
    justify-content: center;
    span {
      font-family: HYQiHei-EES;
      font-size: 12px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
    }
  }
}

// 答题弹窗
.answer-content-dialog {
  width: 90%;
  height: 60vh;
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  bottom: -33%;
  position: relative;

  .question-content {
    width: calc(100vw - 30px);
    display: flex;
    justify-content: center;
    .single-choice {
      height: 50vh;
      width: 90%;
    }
    .answer-title {
      width: 100%;
      margin: 20px 0;
      font-size: 16px;
      color: #333333;
      letter-spacing: 0;
      font-weight: bold;
      max-height: 50px;
      overflow-y: auto;
      .single-choice-text {
        color: #c3c3c3;
        display: block;
        font-size: 14px;
      }
    }
    .question-content-other {
      width: calc(100vw - 50px);
      display: flex;
      justify-content: center;
      .dynamic-property-form {
        width: 321px;
        margin: 20px 0;
        font-size: 18px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 400;
        // 控制其它题型标题
        /deep/ .dynamic-attr-text-title {
          font-size: 16px !important;
          margin-bottom: 10px;
          max-height: 50px;
          overflow-y: auto;
        }
        // 控制其它题型-多行文本输入内容过多下拉展示
        /deep/ .van-field__body {
          height: 20vh;
          overflow-y: auto;
        }
        // 控制其它题型-多选时选项过多可以下拉展示
        /deep/ .check-content {
          height: 40vh;
          overflow-y: auto;
        }
      }
    }
    .answer-content-height {
      height: 72%;
      overflow-y: auto;
      .answer-content {
        width: 90%;
        min-width: 260px;
        .answer-option {
          width: 100%;
          background: #f5f5f5;
          border-radius: 21px;
          margin-bottom: 21px;
          span {
            font-size: 14px;
            color: #000000;
            letter-spacing: 0;
            font-weight: 400;
            display: inline-block;
            padding: 11px 11px 12.5px 15px;
          }
        }
        .selected-answer-option {
          background: #d3e2ff;
          border: 1px solid #256fff;
          span {
            color: #256fff;
          }
        }
      }
    }
  }
  .status-info {
    background: #fff;
  }

  .btn-list {
    display: flex;
    width: 100%;
    justify-content: space-between;
    position: absolute;
    bottom: 10%;
    padding-top: 6px;
    background: #fff;
    .btn {
      width: 140px;
      height: 36px;
      margin: 0 auto;
      font-size: 14px;
      background: #256fff;
      border-radius: 18px;
    }
  }
  .answer-process {
    display: flex;
    position: absolute;
    bottom: 1%;
    .current,
    .sum {
      font-size: 14px;
      color: #256fff;
      letter-spacing: 0;
      font-weight: 400;
    }
  }
}

// 抽奖弹窗
.dialog {
  width: 80%;
  border-radius: 15px;
  .dialog-content {
    padding: 3% 4% 8% 4%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .dialog-img {
      margin: 19px auto;
      display: flex;
      align-items: center;
      img {
        width: 200px;
        height: 140px;
      }
    }
    .content-top {
      margin: 0 auto;
      span {
        font-size: 18px;
        font-weight: 500;
        line-height: normal;
        letter-spacing: normal;
        color: #030303;
      }
    }
    .content-bottom {
      display: flex;
      justify-content: center;
      margin-top: 8%;
      .v-button {
        width: 92%;
        >>> .van-button {
          height: 44px !important;
          width: 100% !important;
          display: block !important;
        }
      }
    }
    .share {
      height: 1.9%;
      display: flex;
      justify-content: center;
      flex-direction: row;
      align-items: center;
      margin-top: 2%;
      img {
        width: 13.5px;
        height: 13.5px;
        margin-right: 1%;
      }
      span {
        width: 28px;
        font-size: 12px;
      }
    }
  }
}

// 活动未开始、已结束
.dialogEnd {
  width: 80%;
  height: 50vh;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .endTitle {
    font-family: HYQiHei-FES;
    font-size: 18px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    margin-bottom: 3.2%;
  }
  .endImage {
    display: flex;
    justify-content: center;
    margin-bottom: 4.8%;
    img {
      width: 50.3%;
    }
  }
  .activityTime {
    font-family: HYQiHei-EES;
    font-size: 14px;
    color: #999999;
    text-align: center;
    line-height: 23px;
    font-weight: 400;
    .time {
      font-size: 13px;
    }
  }
}

.fs-16 {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/interest-form/interestForm.vue